import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { message } from "antd";

import { CiCircleChevLeft } from "react-icons/ci";

import { AuthAction } from "../../store/actions";

import LoginLayout from "../../components/layouts/login-layout";
import {
  Buttons,
  Spacer,
  inputFields,
  checkbox,
  loginAndSignup,
} from "../../components";

import { Images, Utils } from "../../config";

const Login = () => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });

  const handleLogin = () => {
    if (!state.email) {
      message.error("Email can not be left empty.");
    } else if (Utils.emailRegex.test(state.email) === false) {
      message.error("Please enter a valid email address.");
    } else if (!state.password) {
      message.error("Password can not be left empty.");
    } else {
      const body = {
        email: state.email,
        password: state.password,
        rememberMe: state.rememberMe,
      };
      dispatch(AuthAction.SignIn(body));
    }
  };
  const handleGuest = () => {
    const body = {
      email: "univisionstudent@yopmail.com",
      password: "Student123",
      rememberMe: true,
    };
    dispatch(AuthAction.SignIn(body));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <LoginLayout img={true}>
      <div className="flex flex-col items-center justify-center py-[3.75em] bg-login-gradient gap-[2.5em] w-[43.75em] h-full">
        <img src={Images.UnivisionLogoWithText} className="h-[3.75em]" />

        <div className="flex flex-col gap-[1.25em] justify-center items-center">
          <div className="text-main font-bold text-[3.5em]">Welcome</div>
          <div className="text-[1.6875em] font-semibold">Login to Continue</div>
        </div>

        <div className="flex flex-col gap-[0.125em] w-[28.125em]">
          <loginAndSignup.LoginInputTitle title="Email Address" />
          <inputFields.DefaultInput
            onChange={(e) => setState({ ...state, email: e.target.value })}
            value={state?.email}
            onKeyDown={handleKeyDown}
            placeholder="xyz@abc.com"
          />
          <Spacer height={5} />
          <loginAndSignup.LoginInputTitle title="Password" />
          <inputFields.DefaultInput
            type="password"
            onChange={(e) => setState({ ...state, password: e.target.value })}
            value={state?.password}
            onKeyDown={handleKeyDown}
            placeholder="Enter your password"
          />
          <div className="flex justify-between items-center font-medium">
            <checkbox.DefaultCheckbox
              text="Remember Me"
              onChange={(e) => {
                setState({ ...state, rememberMe: e.target.checked });
              }}
              checked={state.rememberMe}
            />
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>
          <Spacer height={30} />
          <Buttons.DefaultButton onClick={handleLogin} width="full">
            Login
          </Buttons.DefaultButton>
          <Spacer height={30} />
          <div className="flex justify-center items-center font-medium gap-1">
            <div>Don't have an account? </div>
            <Link to="/signup/general-info">
              <div className="text-main font-bold">Sign Up</div>
            </Link>
          </div>
          <div className="flex justify-center items-center text-[1.125em] font-medium gap-1 underline">
            <div onClick={handleGuest} className="cursor-pointer w-max">
              Continue as guest
            </div>
          </div>
        </div>
      </div>
    </LoginLayout>
  );
};

export default Login;
